import { ChevronLeft, Menu, Moon, Sun } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TopBar = ({ 
  theme, 
  isDark, 
  setIsDark, 
  title, 
  onBackClick, 
  showMenu = true, 
  isMenuOpen, 
  setIsMenuOpen,
  fixed = true,
  backgroundColor,
  customRightActions
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1, { state: { isDark } });
    }
  };

  const containerClass = fixed 
    ? "fixed top-0 left-1/2 -translate-x-1/2 w-full flex justify-between items-center px-6 py-4 z-20 border-b"
    : "flex-none flex justify-between items-center px-6 py-4 z-20 border-b";

  const bgColor = backgroundColor || theme.background2;

  return (
    <div 
      className={containerClass}
      style={{ backgroundColor: bgColor, borderColor: theme.stroke }}
    >
      <button
        className="p-1"
        onClick={handleBackClick}
        style={{ color: theme.text }}
      >
        <ChevronLeft size={24} />
      </button>

      <h1
        className="text-lg font-semibold"
        style={{ color: theme.text }}
      >
        {title}
      </h1>

      <div className="flex items-center gap-2">
        {customRightActions ? (
          customRightActions
        ) : (
          <>
            {showMenu && (
              <button
                onClick={() => setIsMenuOpen && setIsMenuOpen(!isMenuOpen)}
                className="w-10 h-10 rounded-full hidden md:flex items-center justify-center"
                style={{ color: theme.text }}
              >
                <Menu size={20} />
              </button>
            )}

            <button
              onClick={() => setIsDark(!isDark)}
              className="w-10 h-10 rounded-full flex items-center justify-center"
              style={{ color: theme.text }}
            >
              {isDark ? <Moon size={20} /> : <Sun size={20} />}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default TopBar;
